import { inject, provideAppInitializer, signal } from '@angular/core';
import { PlatformService } from 'ngx-unificator/services';
import { WA_WINDOW } from 'ngx-unificator/tokens';

export const skipBotRules = signal<boolean>(null);

export const provideBotRules = () => {
  return [
    provideAppInitializer(() => {
      const platform = inject(PlatformService);
      const window = inject(WA_WINDOW);
      if (platform.isBrowser) {
        skipBotRules.set(isBot(window.navigator.userAgent));
      }
    }),
  ];
}

const botList = ['PetalBot', 'Googlebot', 'Chrome-Lighthouse', 'SemrushBot', 'AhrefsBot', 'bingbot', 'Yahoo', 'Yandex', 'Google-inspectiontool', 'google page speed insights', 'facebookexternalhit', 'slackbot', 'google'];

function isBot(userAgent: string = '') {
  return Boolean(botList.filter(e => userAgent.toLowerCase().includes(e.toLowerCase())).length);
}
